export default __webpack_public_path__ + "static/berufsreise.bannerbox-0a31513531c94565f62c923e48e8b78b.jpg";